(() => {
  const dialog = document.querySelector('[data-chikas-qb]');
  if (!dialog) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ANIM_MS = reduceMotion ? 0 : 320;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const el = {
    image: dialog.querySelector('[data-qb-image]'),
    title: dialog.querySelector('[data-qb-title]'),
    meta: dialog.querySelector('[data-qb-meta]'),
    price: dialog.querySelector('[data-qb-price]'),
    compare: dialog.querySelector('[data-qb-compare]'),
    form: dialog.querySelector('[data-qb-form]'),
    variant: dialog.querySelector('[data-qb-variant]'),
    options: dialog.querySelector('[data-qb-options]'),
    qty: dialog.querySelector('[data-qb-qty-input]'),
    error: dialog.querySelector('[data-qb-error]'),
    add: dialog.querySelector('[data-qb-add]'),
    buy: dialog.querySelector('[data-qb-buy]'),
    link: dialog.querySelector('[data-qb-link]'),
  };
  const loadingHtml = el.options.innerHTML;

  const cache = new Map();
  let product = null;
  let selected = [];
  let current = null;
  let token = 0;
  let closingTimer = 0;

  const money = (cents) => {
    if (typeof window.ChikasMoney === 'function') {
      return String(window.ChikasMoney(cents)).replace(/[.,]00(?!\d)/, '').replace(/^\$(?=\d)/, '$ ');
    }
    return `$ ${Math.round(Number(cents) / 100).toLocaleString('es-CO')}`;
  };

  const escapeHtml = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const optionNames = (p) => (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));

  const isDefaultOnly = (p) =>
    p.variants.length === 1 && /default title/i.test(p.variants[0].title || '');

  const findVariant = () =>
    product.variants.find((v) => v.options.every((val, i) => val === selected[i])) || null;

  const valueAvailable = (index, value) =>
    product.variants.some(
      (v) => v.available && v.options[index] === value && v.options.every((val, i) => i === index || val === selected[i])
    );

  const showError = (msg) => {
    el.error.textContent = msg || '';
    el.error.hidden = !msg;
  };

  const setBusy = (busy) => {
    dialog.classList.toggle('is-busy', busy);
    const ok = !busy && current && current.available;
    el.add.disabled = !ok;
    el.buy.disabled = !ok;
  };

  const renderPrice = (v) => {
    const price = v ? v.price : product ? product.price : null;
    const compare = v ? v.compare_at_price : null;
    if (price != null) el.price.textContent = money(price);
    const onSale = compare && compare > price;
    el.compare.hidden = !onSale;
    el.compare.textContent = onSale ? money(compare) : '';
  };

  const renderOptions = () => {
    if (isDefaultOnly(product)) {
      el.options.innerHTML = '';
      return;
    }
    const names = optionNames(product);
    el.options.innerHTML = names
      .map((name, i) => {
        const values = [...new Set(product.variants.map((v) => v.options[i]))];
        const buttons = values
          .map((val) => {
            const on = selected[i] === val;
            const avail = valueAvailable(i, val);
            return `<button type="button" class="chikas-qb__opt${on ? ' is-selected' : ''}${avail ? '' : ' is-soldout'}" data-qb-opt="${i}" data-value="${escapeHtml(val)}" aria-pressed="${on}" ${avail ? '' : 'aria-disabled="true"'}>${escapeHtml(val)}</button>`;
          })
          .join('');
        return `<div class="chikas-qb__group">
          <p class="chikas-qb__label">${escapeHtml(name)}: <strong>${escapeHtml(selected[i] || '')}</strong></p>
          <div class="chikas-qb__values" role="group" aria-label="${escapeHtml(name)}">${buttons}</div>
        </div>`;
      })
      .join('');
  };

  const sync = () => {
    current = findVariant();
    el.variant.value = current ? current.id : '';
    renderOptions();
    renderPrice(current);
    if (product.url || product.handle) {
      const base = product.url || `${root}products/${product.handle}`;
      el.link.href = current ? `${base}?variant=${current.id}` : base;
    }
    if (!current) showError('Esta combinación no está disponible.');
    else if (!current.available) showError('Esta talla está agotada.');
    else showError('');
    setBusy(false);
  };

  const load = async (handle) => {
    if (cache.has(handle)) return cache.get(handle);
    const res = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('No se pudo cargar la prenda');
    const data = await res.json();
    cache.set(handle, data);
    return data;
  };

  const open = async (card) => {
    const handle = card.dataset.favHandle;
    if (!handle) return;
    const my = ++token;

    product = null;
    current = null;
    el.image.src = card.dataset.favImage || '';
    el.image.alt = card.dataset.favTitle || '';
    el.title.textContent = card.dataset.favTitle || '';
    el.meta.textContent = card.dataset.favMeta || '';
    el.meta.hidden = !card.dataset.favMeta;
    el.price.textContent = card.dataset.favPrice || '';
    el.compare.hidden = true;
    el.qty.value = '1';
    el.link.href = card.dataset.favUrl || '#';
    el.options.innerHTML = loadingHtml;
    showError('');
    setBusy(true);

    window.clearTimeout(closingTimer);
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('chikas-drawer-open');
    requestAnimationFrame(() => dialog.classList.add('is-open'));

    try {
      const data = await load(handle);
      if (my !== token) return;
      product = data;
      const first = data.variants.find((v) => v.available) || data.variants[0];
      selected = first ? [...first.options] : [];
      sync();
    } catch (e) {
      if (my !== token) return;
      el.options.innerHTML = '';
      showError('No pudimos cargar las tallas. Intenta de nuevo o entra a la prenda.');
    }
  };

  const close = (instant) => {
    if (!dialog.open) return;
    token++;
    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('chikas-drawer-open');
    window.clearTimeout(closingTimer);
    if (instant || !ANIM_MS) {
      dialog.classList.remove('is-closing');
      dialog.close();
      return;
    }
    dialog.classList.add('is-closing');
    closingTimer = window.setTimeout(() => {
      dialog.close();
      dialog.classList.remove('is-closing');
    }, ANIM_MS);
  };

  const quantity = () => Math.max(1, parseInt(el.qty.value, 10) || 1);

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-chikas-quickbuy]');
    if (!trigger) return;
    e.preventDefault();
    const card = trigger.closest('[data-chikas-card]');
    if (card) open(card);
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.closest('[data-chikas-qb-close]')) {
      close();
      return;
    }
    const opt = e.target.closest('[data-qb-opt]');
    if (opt && product) {
      selected[Number(opt.dataset.qbOpt)] = opt.dataset.value;
      if (!findVariant()) {
        const fallback = product.variants.find(
          (v) => v.available && v.options[Number(opt.dataset.qbOpt)] === opt.dataset.value
        );
        if (fallback) selected = [...fallback.options];
      }
      sync();
      return;
    }
    const step = e.target.closest('[data-qb-qty]');
    if (step) {
      el.qty.value = String(Math.max(1, quantity() + Number(step.dataset.qbQty)));
    }
  });

  el.qty.addEventListener('change', () => {
    el.qty.value = String(quantity());
  });

  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    close();
  });

  el.form.addEventListener('submit', (e) => {
    if (!current || !current.available) {
      e.preventDefault();
      e.stopPropagation();
      showError(current ? 'Esta talla está agotada.' : 'Elige una talla.');
      return;
    }
    el.qty.value = String(quantity());
    close(true);
  });

  el.buy.addEventListener('click', async () => {
    if (!current || !current.available) return;
    setBusy(true);
    showError('');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: quantity() }] }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || '');
      }
      window.location.href = `${root}checkout`;
    } catch (err) {
      setBusy(false);
      showError('No pudimos agregar esta prenda. Revisa la talla o la cantidad disponible.');
    }
  });
})();
